<template>
  <div class="whole orders">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-date-picker style="float: left;" v-model="startDate" type="date" placeholder="请选择开始日期">
        </el-date-picker>
        <el-date-picker style="float: left;" v-model="endDate" type="date" placeholder="请选择截止日期">
        </el-date-picker>
        <el-button @click="bonusItemExport" type="primary" style="float: left;">导出明细</el-button>
      </div>
      <div class="userTable">
        <el-table :data="bonusDatas" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
          <el-table-column prop="dividend" label="月度分红红利" width="200">
          </el-table-column>
          <el-table-column prop="coupon" label="月度分红现金券" width="200">
          </el-table-column>
          <el-table-column prop="distribution" label="分销奖" width="200">
          </el-table-column>
          <el-table-column prop='market' label="市场管理奖" width="200">
          </el-table-column>
          <el-table-column prop='afterPurchase' label="复消奖" width="200">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Loading
  } from 'element-ui'
  import MSidebar from 'components/header/sidebar'
  import MHeader from 'components/header/header'
  import {
    getBonusByTime,
    bonusItemExport
  } from 'api/request'
  import {
    ERR_OK
  } from 'api/config'
  import {
    formatDate,
    loadingInstance,
    Success,
    Error
  } from 'common/js/util'
  export default {
    components: {
      MSidebar,
      MHeader
    },
    data() {
      return {
        token: window.localStorage.getItem("token"),
        paginationShow: false,
        state: '301',
        startDate: null,
        endDate: null,
        bonusDatas: null
      }
    },
    mounted() {
      let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
      if (!getUserInfo) {
        this.$router.push({
          path: '/'
        })
      } else {
        this.fileyHeader = {
          token: getUserInfo.token,
          'Content-Type': 'application/json;charset=utf-8'
        }
        this._getList();
      }
    },
    methods: {

      _getList() {
        let param = {
          startDate: this.startDate,
          endDate: this.endDate
        }
        loadingInstance(Loading)
        getBonusByTime(param).then((res) => {
          loadingInstance(Loading).close()
          if (res.status === ERR_OK) {
            this.bonusDatas = res.data
            debugger
          } else {
            Error(this, res)
          }
        })
      },
      bonusItemExport() {
        location.href = bonusItemExport + "startDate=" + this.formatDate(this
          .startDate) + "&endDate=" + this.formatDate(this.endDate);
      },

      formatDate(date) {
        if (date != null && date != 'null' && date != undefined) {
          date = new Date(Date.parse(date)); //转换成Data();
          var y = date.getFullYear();
          var m = date.getMonth() + 1;
          m = m < 10 ? '0' + m : m;
          var d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          return y + '-' + m + '-' + d;
        } else {
          return "";
        }

      }
    },
  }
</script>
<style scoped>

  .user {
    z-index: 9;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #F8F8F8;
  }

  .userOperate {
    height: 50px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 30px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .userTable {
    padding: 10px;
    position: relative;
  }
</style>
<style>
  .orders table tr.el-table__row--level-0 {
    background-color: #f7e7e7 !important;
  }

  .userOperate .el-input {
    width: 180px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }

  .userOperate .el-button {
    width: 100px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/finance/bonus.vue